import { PageHeader, Popconfirm, message, Rate, Button, Tooltip } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";
import { connect } from "react-redux";
import { StopOutlined, EditOutlined, CheckCircleOutlined, ImportOutlined, ExportOutlined, TableOutlined } from '@ant-design/icons'
import * as XLSX from 'xlsx'
import HeaderActions from "../../../Components/HeaderActions";
import ModalCalificacionProveedor from "./ModalCalificacionProvedoor/ModalCalificacionProvedoor";
import moment from "moment";
  import "moment/locale/es";
  moment.locale("es");


class Proveedores extends Component {
  state = {
    todasProveedores: [],
    loading: false,
    valor: 1,
    modalVisible: false,
    proveedorSeleccionado: null,
    calificaciones: {
      precio: 0,
      calidad: 0,
      servicio: 0,
      tiempoEntrega: 0
    }
  }
  componentDidMount() {
    this.consultarProveedores(this.state.valor);
  }

  abrirModalCalificacion(proveedor) {
    this.setState({
      modalVisible: true,
      proveedorSeleccionado: proveedor,
      calificaciones: {
        precio: proveedor.calificacionDetalle?.precio || 0,
        calidad: proveedor.calificacionDetalle?.calidad || 0,
        servicio: proveedor.calificacionDetalle?.servicio || 0,
        tiempoEntrega: proveedor.calificacionDetalle?.tiempoEntrega || 0
      }
    });
  }

  // Función para cerrar el modal
  cerrarModal() {
    this.setState({
      modalVisible: false,
      proveedorSeleccionado: null,
      calificaciones: {
        precio: 0,
        calidad: 0,
        servicio: 0,
        tiempoEntrega: 0
      }
    });
    this.consultarProveedores(this.state.valor);
  }

  consultarProveedores(valor) {
    this.setState({loading: true})
    axios
    .post(
      "proveedores/selectTodosProveedores",
      { empresaId: this.props.empresaId, valor: valor },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      this.setState({loading: false})
      if (res.data.status === 404) {
        this.setState({ todasProveedores: [] });
      } else {
        this.setState({
          todasProveedores: res.data
        });
      }
    });
  }
  agregarProveedor(){
    this.props.history.push('/panel/agregarProveedor')
  }
  importarProveedores(){
    this.props.history.push('/panel/importarProveedores')
  }
  edicionMasivaProveedores(){
    this.props.history.push('/panel/edicionMasivaProveedores')
  }
  editarProveedor(id){
    this.props.history.push('/panel/editarProveedor', {id})
  }

  exportarProveedores() {
    this.setState({ loading: true });
    axios
      .post(
        "proveedores/exportarProveedores", 
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontraron datos para exportar");
        } else {
          const datosProveedores = res.data.data.map(proveedor => ({
            "Código": proveedor.codigo,
            "Razón Social": proveedor.razonSocial,
            "Nombre Persona Física": proveedor.nombre,
            "Apellido Paterno": proveedor.apellidoPaterno,
            "Apellido Materno": proveedor.apellidoMaterno,
            "CURP": proveedor.curp,
            "RFC": proveedor.rfc,
            "Teléfono Empresa": proveedor.telefono,
            "Correo Empresa": proveedor.correo,
            "Cuenta Banco": proveedor.cuentaBanco,
            "Cuenta Clabe": proveedor.CuentaClabe,
            "Dias de Crédito": proveedor.diasCredito ? proveedor.diasCredito : "",
            "Limite de Crédito": proveedor.limiteCredito ? proveedor.limiteCredito : "",
            "Tipo de Tercero": (proveedor.tipoTercero === 1) ? "04 - Proveedor Nacional" : (proveedor.tipoTercero === 2) ? "05 - Proveedor Extranjero" : (proveedor.tipoTercero === 3) ? "15 - Proveedor Global" : "Tipo desconocido",
            "Tipo de operación": proveedor.TipoOperacion,
            "Código Postal": proveedor.cp,
            "Colonia": proveedor.coloniaText,
            "Calle": proveedor.calle,
            "Número": proveedor.numeroCalle,
            "Número Int": proveedor.numeroInterior,
            "Nombre Contacto": proveedor.nombreContacto,
            "Teléfono Contacto": proveedor.telefonoContacto,
            "Correo Contacto": proveedor.correoContacto,
            "Jefe del Contacto": proveedor.jefeContcto,
            "Persona de Pedidos": proveedor.personasPedidos,
            "Puesto del Jefe de Contacto": proveedor.puestoJefeContacto,
            "Observaciones": proveedor.observaciones,
            "Registro de Infonavit": proveedor.infonavit,
            "Registro Patronal": proveedor.registroPatronal,
            "Registro de la Cámara": proveedor.registroCamara,
            "Fecha de Alta" :  moment(proveedor.createdAt).format("DD/MM/YYYY"),
            
          }));
          const ws = XLSX.utils.json_to_sheet(datosProveedores);
          const encabezados = Object.keys(datosProveedores[0]);  
          ws["!cols"] = encabezados.map(() => ({ wch: 20 }));
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Proveedores");
          XLSX.writeFile(wb, "Proveedores.xlsx");
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
        message.error("Ocurrió un error al generar el archivo");
      });
}

  deshabilitarProveedor(value) {
    axios
      .post(
        "proveedores/deshabilitarProveedor",
        { proveedorId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Proveedor deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarProveedores(this.state.valor);
      });
  }
  habilitarProveedor(value) {
    axios
      .post(
        "proveedores/habilitarProveedor",
        { proveedorId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Proveedor habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarProveedores(this.state.valor);
      });
  }
  render() {
    const columns = [
      {
        title: "Código",
        dataIndex: "codigo",
        key: "codigo",
        width: "6%",
        defaultSortOrder: "ascend",
        sorter: (a, b) => {
          const aStr = a.codigo || '';
          const bStr = b.codigo || '';
          const aNum = Number(aStr);
          const bNum = Number(bStr);
          const aIsNum = aStr !== '' && !isNaN(aNum);
          const bIsNum = bStr !== '' && !isNaN(bNum);
          if (aIsNum && bIsNum) return aNum - bNum;
          if (aIsNum) return -1;
          if (bIsNum) return 1;
          return aStr.localeCompare(bStr, undefined, { numeric: true, sensitivity: 'base' });
        },
        buscar: "codigo",
        ellipsis: true,
      },
      {
        title: "Nombre",
        dataIndex: "nombre",
        width: "22%",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
        ellipsis: true,
      },
      {
        title: "Nombre Comercial",
        dataIndex: "nombreComercial",
        width: "18%",
        key: "nombreComercial",
        sorter: (a, b) => {
          if (a.nombreComercial < b.nombreComercial) {
            return -1;
          }
          if (a.nombreComercial > b.nombreComercial) {
            return 1;
          }
          return 0;
        },
        buscar: "nombreComercial",
        ellipsis: true,
      },
      {
        title: "RFC",
        dataIndex: "rfc",
        width: "10%",
        key: "rfc",
        sorter: (a, b) => {
          if (a.rfc < b.rfc) {
            return -1;
          }
          if (a.rfc > b.rfc) {
            return 1;
          }
          return 0;
        },
        buscar: "rfc",
        ellipsis: true,
      },
      {
        title: "Tipo de Proveedor",
        dataIndex: "tipoProveedor",
         width: "20%",
        key: "tipoProveedor",
        ellipsis: true,

      },
      {
        title: "Calificación",
        dataIndex: "calificacion",
        width: "10%",
        key: "calificacion",
        sorter: (a, b) => (a.calificacion || 0) - (b.calificacion || 0),
        render: (_, record) => (
          <Button
            type="text"
            onClick={() => this.abrirModalCalificacion(record)}
            style={{
              padding: 0,
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              width: '100%'
            }}
          >
            <div>
            <div style={{ fontSize: '11px', color: '#666', marginTop: '2px', display: 'flex', alignItems: 'center' }}>
              <Rate
                value={record.calificacion || 0}
                disabled
                allowHalf
                style={{ fontSize: 16, pointerEvents: 'none' }} 
              />
              <span style={{ marginLeft: 8 }}>
                {record.calificacion ? `${record.calificacion}/5` : 'S/C'}
              </span>
            </div>
            </div>
          </Button>
        )
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        width: "9%",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Editar
          if (this.props.permisoEditarProveedor) {
            buttons.push(
              <Tooltip title="Editar Proveedor" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarProveedor(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoDeshabilitarProveedor) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar este proveedor"
                  onConfirm={() => this.deshabilitarProveedor(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar este proveedor"
                  onConfirm={() => this.habilitarProveedor(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },

    ];
    return (
      <>
        <PageHeader
          title="Proveedores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
           
            {window.innerWidth > 1000 && (
              <SegmentedItem
                options={[{label: 'Activo', value: 1}, {label: 'Deshabilitado', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarProveedores(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
            )}
            <HeaderActions>
                <ButtonItem
                  type="default"
                  icon={<ImportOutlined />}
                  onClick={() => this.importarProveedores()}
                >
                  Importar Proveedores
                </ButtonItem>
                <ButtonItem
                  type="default"
                  icon={<ExportOutlined />}
                  azulMarino
                  onClick={() => this.exportarProveedores()}
                >
                  Exportar Proveedores
                </ButtonItem>
                {this.props.permisoEditarProveedor && (
                  <ButtonItem
                    type="default"
                    verde
                    icon={<TableOutlined />}
                    onClick={() => this.edicionMasivaProveedores()}
                  >
                    Edición Masiva
                  </ButtonItem>
                )}
            </HeaderActions>

            {this.props.permisoAgregarProveedor && (
              <ButtonItem
                type="primary"
                olivo
                onClick={() => this.agregarProveedor()}
                 className="botonAgregar"
              >
                Agregar Proveedor
              </ButtonItem>
            )}
            </div>
          }
        />
        <TableItem 
          showClearFilters
          loading={this.state.loading} 
          size='small' 
          dataSource={this.state.todasProveedores} 
          columns={columns} 
          onRow={(record) => ({
            onDoubleClick: () => this.editarProveedor(record._id),
          })}
        />
        <ModalCalificacionProveedor
          visible={this.state.modalVisible}
          proveedor={this.state.proveedorSeleccionado}
          calificaciones={this.state.calificaciones}
          onCancel={() => this.cerrarModal(false)} // Cerrar sin recargar
          onSuccess={() => this.cerrarModal(true)} // Cerrar y recargar después de guardar
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
        />


      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarProveedor: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cd70cf30e81b54183cf91")?.activado,
    permisoEditarProveedor: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cd738f30e81b54183cf92")?.activado,
    permisoDeshabilitarProveedor: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ce49ef30e81b54183cfb3")?.activado,
  };
};

export default connect(mapStateToProps)(Proveedores);
